import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

interface AppointmentTypeSelectorProps {
  appointmentType: 'user' | 'anonymous';
  onTypeChange: (type: 'user' | 'anonymous') => void;
}

export const AppointmentTypeSelector: React.FC<AppointmentTypeSelectorProps> = ({
  appointmentType,
  onTypeChange
}) => {
  const { t } = useTranslation('manage');

  return (
    <Form.Item
      label={t('appointmentComponents.create.appointmentType.label')}
      name="appointmentType"
      rules={[{ required: true, message: t('appointmentComponents.create.appointmentType.required') }]}
      initialValue="anonymous"
    >
      <Select
        size="middle"
        onChange={onTypeChange}
      >
        <Option value="user">{t('appointmentComponents.create.appointmentType.registeredUser')}</Option>
        <Option value="anonymous">{t('appointmentComponents.create.appointmentType.anonymousGuest')}</Option>
      </Select>
    </Form.Item>
  );
};
